import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { enableMapSet } from 'immer'
import { ProductsProvider } from 'ui'
import { PIPProvider } from './app/hooks/usePIP'
import { ChatProvider } from '@gojiraf/chat'
import store from './app/core/store'
import { App } from './App'
import reportWebVitals from './reportWebVitals'
import './i18n'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'

enableMapSet()

const queryClient = new QueryClient()

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ChatProvider>
        <ProductsProvider>
          <Provider store={store}>
            <PIPProvider>
              <App />
            </PIPProvider>
          </Provider>
        </ProductsProvider>
      </ChatProvider>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
